module.exports = __webpack_public_path__ + "static/img/qiyewenhua_title.8335f0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/qiyewenhua_title.png
// module id = lkOU
// module chunks = 0